import { SEARCH_INPUT_NAMES, SEARCH_INPUT_TYPES } from './searchTypes';
import { sortByNameInAlphabeticalOrder } from '../../../utils/miscellaneous/sortings';


const EXCLUDE_DROPDOWN_OPTIONS = [
    {
        label: 'search.dropdown.option.label.contains',
        value: true
    },
    {
        label: 'search.dropdown.option.label.not_contain',
        value: false
    }
];

const getOptions = loadedOptions => {
    return [
        {
            label: 'search.dropdown.option.label.select',
            value: null
        },
        ...sortByNameInAlphabeticalOrder(
            loadedOptions.map(({ name }) => {
                return {
                    label: name,
                    value: name
                };
            }),
            'label'
        )
    ];
};

export const getSearchConfig = lists => {

    const {
        roles = [],
        tags = [],
        workgroups = []
    } = lists;

    return [
        [
            {
                label: 'search.label.name',
                inputs: [
                    {
                        name: SEARCH_INPUT_NAMES.NAME,
                        placeholder: 'search.placeholder.name',
                        type: SEARCH_INPUT_TYPES.INPUT,
                        validation: 25
                    }
                ]
            },
            {
                label: 'search.label.filter',
                inputs: [
                    {
                        name: SEARCH_INPUT_NAMES.CONTAINS_TAG,
                        options: EXCLUDE_DROPDOWN_OPTIONS,
                        type: SEARCH_INPUT_TYPES.DROPDOWN,
                        labelClass: 'sr-only',
                        srLabelText: 'Tag',
                    },
                ]
            },
            {
                label: 'search.label.tag',
                inputs: [
                    {
                        name: SEARCH_INPUT_NAMES.TAG,
                        options: getOptions(tags),
                        type: SEARCH_INPUT_TYPES.DROPDOWN,
                    }
                ],
            },
            {
                label: 'search.label.filter',
                inputs: [
                    {
                        name: SEARCH_INPUT_NAMES.CONTAINS_WORKGROUP,
                        options: EXCLUDE_DROPDOWN_OPTIONS,
                        type: SEARCH_INPUT_TYPES.DROPDOWN,
                        labelClass: 'sr-only',
                        srLabelText: 'Workgroup',
                    }
                ],
            },
            {
                label: 'search.label.workgroup',
                inputs: [
                    {
                        name: SEARCH_INPUT_NAMES.WORKGROUP,
                        options: getOptions(workgroups),
                        type: SEARCH_INPUT_TYPES.DROPDOWN
                    }
                ]
            }
        ],
        [
            {
                label: 'search.label.role',
                inputs: [
                    {
                        name: SEARCH_INPUT_NAMES.ROLE,
                        options: getOptions(roles),
                        type: SEARCH_INPUT_TYPES.DROPDOWN
                    }
                ]
            },
            {
                label: 'search.label.creation_date',
                inputs: [
                    {
                        name: SEARCH_INPUT_NAMES.AFTER_DATE,
                        placeholder: 'search.placeholder.from',
                        type: SEARCH_INPUT_TYPES.DATEPICKER
                    },
                    {
                        name: SEARCH_INPUT_NAMES.BEFORE_DATE,
                        placeholder: 'search.placeholder.to',
                        type: SEARCH_INPUT_TYPES.DATEPICKER
                    }
                ]
            },
            // Support for Untagged only checkbox is removed for a while
        ]
    ];
};